import { render } from "./UnitSetup.vue?vue&type=template&id=601dec21&scoped=true"
import script from "./UnitSetup.vue?vue&type=script&lang=js"
export * from "./UnitSetup.vue?vue&type=script&lang=js"

import "./UnitSetup.vue?vue&type=style&index=0&id=601dec21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601dec21"]])

export default __exports__